@if (loading) {
  <app-loader></app-loader>
} @else {
  <app-show-transcript [transcript]="transcript" (closeEvent)="closeModal($event)"></app-show-transcript>
}
